import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { BrandLoader } from './components/Skeletons'
import { useAuth } from './context/AuthContext'

const Landing = lazy(() => import('./pages/Landing'))
const AuthPage = lazy(() => import('./pages/AuthPage'))
const DashboardLayout = lazy(() => import('./components/DashboardLayout'))
const LinksPage = lazy(() => import('./pages/dashboard/LinksPage'))
const DesignLayout = lazy(() => import('./pages/design/DesignLayout'))
const ProfileDesignPage = lazy(() => import('./pages/design/ProfileDesignPage'))
const ButtonsDesignPage = lazy(() => import('./pages/design/ButtonsDesignPage'))
const SectionsDesignPage = lazy(() => import('./pages/design/SectionsDesignPage'))
const PaletteDesignPage = lazy(() => import('./pages/design/PaletteDesignPage'))
const FontDesignPage = lazy(() => import('./pages/design/FontDesignPage'))
const BackgroundDesignPage = lazy(() => import('./pages/design/BackgroundDesignPage'))
const CtaDesignPage = lazy(() => import('./pages/design/CtaDesignPage'))
const AnalyticsPage = lazy(() => import('./pages/dashboard/AnalyticsPage'))
const SettingsPage = lazy(() => import('./pages/dashboard/SettingsPage'))
const PreviewPage = lazy(() => import('./pages/dashboard/PreviewPage'))
const TemplatesGalleryPage = lazy(() => import('./pages/dashboard/TemplatesGalleryPage'))
const MyTemplatesPage = lazy(() => import('./pages/dashboard/MyTemplatesPage'))
const PublicPage = lazy(() => import('./pages/PublicPage'))
const LegalPage = lazy(() => import('./pages/LegalPage'))
const NotFound = lazy(() => import('./pages/NotFound'))

function ScreenLoader() { return <BrandLoader /> }

function Protected() {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <ScreenLoader />
  return user ? <DashboardLayout /> : <Navigate to="/login" replace state={{ from: location.pathname }} />
}

export default function App() {
  return <Suspense fallback={<ScreenLoader />}><Routes>
    <Route path="/" element={<Landing />} />
    <Route path="/login" element={<AuthPage mode="login" />} />
    <Route path="/signup" element={<AuthPage mode="signup" />} />
    <Route path="/privacy" element={<LegalPage type="privacy" />} />
    <Route path="/terms" element={<LegalPage type="terms" />} />
    <Route path="/dashboard" element={<Protected />}>
      <Route index element={<Navigate to="links" replace />} />
      <Route path="links" element={<LinksPage />} />
      <Route path="design" element={<DesignLayout />}>
        <Route index element={<Navigate to="profile" replace />} />
        <Route path="profile" element={<ProfileDesignPage />} />
        <Route path="buttons" element={<ButtonsDesignPage />} />
        <Route path="sections" element={<SectionsDesignPage />} />
        <Route path="palette" element={<PaletteDesignPage />} />
        <Route path="font" element={<FontDesignPage />} />
        <Route path="background" element={<BackgroundDesignPage />} />
        <Route path="cta" element={<CtaDesignPage />} />
      </Route>
      <Route path="analytics" element={<AnalyticsPage />} />
      <Route path="settings" element={<SettingsPage />} />
      <Route path="preview" element={<PreviewPage />} />
      <Route path="templates" element={<TemplatesGalleryPage />} />
      <Route path="my-templates" element={<MyTemplatesPage />} />
    </Route>
    <Route path="/:username" element={<PublicPage />} />
    <Route path="*" element={<NotFound />} />
  </Routes></Suspense>
}
